import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 保存舱单格式化货物信息
export function saveManifestGoodsInfo(data) {
  return request({
    url: URL.seaExport.saveManifestGoodsInfo,
    method: 'post',
    data
  })
}

// 批量保存舱单格式化货物信息
export function saveManifestGoodsInfoByBatch(data) {
  return request({
    url: URL.seaExport.saveManifestGoodsInfoByBatch,
    method: 'post',
    data
  })
}

// 删除舱单格式化货物信息
export function deleteManifestGoodsInfo(params) {
  return request({
    url: URL.seaExport.deleteManifestGoodsInfo,
    method: 'delete',
    params
  })
}
